import { Loader2 } from 'lucide-react';

export default function LoadingSpinner({ size = 24, message = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <Loader2 size={size} className="animate-spin text-game-primary" />
      {message && <p className="text-game-text-dim">{message}</p>}
    </div>
  );
}
